import {
  SET_SUB_MENU_ITEMS,
  SET_SUB_MENU_COLLAPSED,
  SET_SUB_MENU_ROUTE,
  SET_ASSET_SUBMENU_ITEMS,
  SET_ASSET_SUBMENU,
} from '../../mutations';

export default {
  setSubMenuItems({ dispatch, commit }, payload) {
    commit(SET_SUB_MENU_ITEMS, payload.items);
    if (!payload.maintainPreviousCollapsedState) {
      dispatch('setSubMenuCollapsed', false);
    }
  },
  setSubMenuCollapsed({ commit }, state) {
    commit(SET_SUB_MENU_COLLAPSED, state);
  },
  setSubMenuRoute({ commit }, state) {
    commit(SET_SUB_MENU_ROUTE, state);
  },
  setAssetSubMenuItems({ commit }, items) {
    commit(SET_ASSET_SUBMENU_ITEMS, items);
  },
  setAssetSubMenu({ commit }, submenu) {
    commit(SET_ASSET_SUBMENU, submenu);
  },
};
